import { getUserEmailFromCookies, getUserIPAddressFromCookies } from './getUserDetailsUtil'
import { KLAVIYO_PUBLIC_API_KEY } from '../../../constants/index'
import { headers } from './headers'

export const trackSearchLocationFromGeneralPages = (location) => {
  const email = getUserEmailFromCookies()
  const ipAddress = getUserIPAddressFromCookies()
  const options = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      data: {
        type: 'event',
        attributes: {
          properties: {
            SearchedLocation: location,
          },
          metric: {data: {type: 'metric', attributes: {name: 'Twisted Road: General Search'}}},
          profile: {
            data: {
              type: 'profile',
              attributes: email ? {
                email: email
              } : {
                id: ipAddress
              }
            }
          }
        }
      }
    })
  }

  fetch(`https://a.klaviyo.com/client/events/?company_id=${KLAVIYO_PUBLIC_API_KEY}`, options)
  .then(response => {
    console.log('klaviyo tracking trackSearchLocationFromGeneralPages success', response)
  })
  .catch(err => {
    console.log('Failed to track trackSearchLocationFromGeneralPages', err)
  })
}
